/* src/app/shared/components/ag-drop-down/ag-single-sublabel-box/ag-single-sublabel-box.component.scss */
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-standard {
  padding-left: 0px;
  position: inherit;
  z-index: 2;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  min-width: 82px;
  border-radius: 12px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  background-color: #ffffff;
  overflow: hidden;
}
.container-fixed {
  padding-left: 0px;
  padding-right: 8px;
  position: fixed;
  z-index: 1010;
  max-height: 100%;
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  background-color: #ffffff;
}
.items-container {
  width: 100%;
}
.item-container {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
}
.hovering-item {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.hovering-item.is-selected {
  padding-right: 8px;
  padding-left: 8px;
}
.hovering-item.is-selected .item {
  background-color: #d9e2ff;
  border-radius: 8px;
  padding: 0px 8px;
}
.hovering-item:hover .item {
  background-color: #f2f2f2;
  border-radius: 8px;
  padding: 0px 8px;
}
.hovering-item:hover {
  padding-right: 8px;
  padding-left: 8px;
}
.item {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.title-item {
  width: 100%;
  height: 33px;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.title {
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  margin-bottom: 0;
}
.item-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 0;
}
.item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-text {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  cursor: pointer;
}
.item-text-bold {
  font-family: "Poppins-Medium";
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  cursor: pointer;
}
.item-row ::ng-deep ag-label .label-box {
  font-family: "Poppins-Medium";
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
}
.divider {
  height: 1px;
  background-color: #dfdfdf;
  margin: 4px 16px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin-bottom: 8px;
}
.top-bottom-padding {
  margin-bottom: 5px;
  padding-bottom: 16px;
  height: fit-content;
  display: block;
  overflow-y: scroll;
  overflow-x: hidden;
}
.form-div {
  position: relative;
  width: 100%;
  padding: 12px;
}
.search-bar {
  display: flex;
  gap: 12px;
  padding: 16px 8px;
  background-color: #f2f2f2;
  border-radius: 12px;
  width: 100%;
  height: 40px;
  align-items: center;
}
.form-img {
  height: 20px;
  width: 20px;
  opacity: 0.5;
}
.search-bar-input {
  width: 95%;
  font-size: 14px;
  border: none;
  background-color: #f2f2f2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
}
.no-result-text {
  color: #a6a6a6;
  text-align: center;
  font-size: 12px;
  font-family: "Poppins-Regular";
}
input:focus {
  outline: none;
}
::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  color: #a6a6a6;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 3px;
}
/*# sourceMappingURL=ag-single-sublabel-box.component.css.map */
